import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { BlockPluckingReportSchemaObject } from "../BlockPluckingReportSchema";
import { validateProperty } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _, { forEach } from 'lodash';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = "BLOCKPLUCKINGREPORT";
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function BlockPluckingReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [fields, setFields] = useState([]);
    const [subFields, setSubFields] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [totalAmount, setTotalAmount] = useState();
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);

    const [blockPluckingReport, setBlockPluckingReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        searchDate: "",
        registrationNumber: "",
        fieldID: "0",
        subFieldID: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        searchDate: "",
        regNo: "0",
        field: "0",
        subField: "0"
    })

    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(BlockPluckingReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["registrationNumber", "fieldName", "subFieldName", "totalAmount"] //"registrationNumber", "fieldName", "progress", "startTime", "endTime", "duration"]
    const csvHeaders = [
        { label: "Reg No", value: "registrationNumber" },
        { label: "Main Field", value: "fieldName" },
        { label: "Sub Fields", value: "subFieldName" },
        { label: "Total", value: "totalAmount" }
    ];

    const [reportData, setReportData] = useState([]);
    const [reportDataOne, setReportDataOne] = useState([]);
    const [keys, setKeys] = useState([]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),

        )
    }, [blockPluckingReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [blockPluckingReport.estateID])

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint()
        )
    }, [blockPluckingReport.divisionID]);

    useEffect(() => {
        trackPromise(
            getSubFeildsByField()
        )
    }, [blockPluckingReport.fieldID]);

    useEffect(() => {
    }, [reportData]);

    function clearTable() {
        setIsTableHide(true);
        setReportData([]);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setBlockPluckingReport({
            ...blockPluckingReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setBlockPluckingReport({
            ...blockPluckingReport,
            estateID: target.value,
            divisionID: "0",
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setBlockPluckingReport({
            ...blockPluckingReport,
            divisionID: target.value
        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setBlockPluckingReport({
            ...blockPluckingReport,
            searchDate: target.value
        });
    }

    function handleFieldChange(target) {
        validateInputs(target);

        setBlockPluckingReport({
            ...blockPluckingReport,
            fieldID: target.value,
            subFieldID: "0",
        });
        clearTable();
    }

    function handleSubFieldChange(target) {
        validateInputs(target);

        setBlockPluckingReport({
            ...blockPluckingReport,
            subFieldID: target.value
        });
        clearTable();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, BlockPluckingReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'BLOCKPLUCKINGREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();

        setBlockPluckingReport({
            ...blockPluckingReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(blockPluckingReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(blockPluckingReport.estateID);
        setDivisions(data);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetFieldsByCollectionPointID(parseInt(blockPluckingReport.divisionID));
        setFields(fields);
    }

    async function getSubFeildsByField() {
        const subFields = await services.GetSubFeildsByFieldID(parseInt(blockPluckingReport.fieldID));
        setSubFields(subFields);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, BlockPluckingReportSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setBlockPluckingReport({
            ...blockPluckingReport,
            [e.target.name]: value
        })
    }

    async function handleSearch(e) {

        e.preventDefault();

        setIsTableHide(true);

        getSelectedDropdownValuesForReport(blockPluckingReport);

        setIsTableHide(true);
        const result = await services.GetBlockPluckingReportData(blockPluckingReport);
        const totalAmount = result.reduce((totalAmount, item) => totalAmount + item.totalAmount, 0)
        setTotalAmount(totalAmount);
        let groupedResult = groupByGtn(result);
        let keys = Object.keys(groupedResult);

        setKeys(keys);
        setReportData(result);
        setReportDataOne(groupedResult);

        if (result.length > 0) {
            result.forEach(x => {
                x.startTime = moment(x.startTime).format('h:mm:ss a');
                x.endTime = moment(x.endTime).format('h:mm:ss a');
            })
            setIsTableHide(false);
        }

        const comlpeteData = [...result];
        setCsvData(comlpeteData)
    }

    function createFile() {
        var settings = {
            sheetName: 'Block Plucking Report',
            fileName: 'BlockPluckingReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            registrationNumber: "Total",
            totalAmount: totalAmount
        }
        var newRow2 = {
            registrationNumber: "Group :" + groups[blockPluckingReport.groupID],
            fieldName: "Operation Entity :" + divisions[blockPluckingReport.divisionID],
            subFieldName: "Collection Point : " + estates[blockPluckingReport.estateID],
            totalAmount: "Generated user : " + tokenService.getUserNameFromToken()
        }
        copyOfCsv.push(newRow1)
        copyOfCsv.push({}, newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            regNo: searchForm.registrationNumber,
            field: fields[searchForm.fieldID],
            subField: subFields[searchForm.subFieldID],
            date: searchForm.searchDate
        })
    }

    function groupByGtn(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['gtnNumber']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Field Wise Block Plucking Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={blockPluckingReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={blockPluckingReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={blockPluckingReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fieldID" >Field *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="fieldID"
                                            id="fieldID"
                                            name="fieldID"
                                            value={blockPluckingReport.fieldID}
                                            onChange={(e) => handleFieldChange(e.target)} >
                                            <MenuItem value="0">--Select Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                        {errors["fieldID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="subFieldID">Sub Field</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="subFieldID"
                                            id="subFieldID"
                                            name="subFieldID"
                                            value={blockPluckingReport.subFieldID}
                                            onChange={(e) => handleSubFieldChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Sub Field--</MenuItem>
                                            {generateDropDownMenu(subFields)}
                                        </Select>
                                        {errors["subFieldID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["subFieldID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField fullWidth label="Registration No"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={blockPluckingReport.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["registrationNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1" style={{ margintop: '30px' }}>
                                        <input
                                            type="button"
                                            className="btn btn-primary"
                                            value="Search"
                                            onClick={e => trackPromise(handleSearch(e))}
                                        />
                                    </div>
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Reg No</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Sub Field</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" align="center"> {row.registrationNumber}</TableCell>
                                                        <TableCell component="th" scope="row" align="center"> {row.subFieldName}</TableCell>
                                                        <TableCell component="th" scope="row" align="center"> {row.totalAmount}</TableCell>
                                                    </TableRow>
                                                )
                                                )}
                                            </TableBody>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalAmount}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={reportData.length}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleLimitChange}
                                            page={page}
                                            rowsPerPage={limit}
                                            rowsPerPageOptions={[5, 10, 25]}
                                        />
                                    </TableContainer>
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Field Wise Block Plucking Details"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} dataOne={reportDataOne}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys} totalAmount={totalAmount} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
